<div class="modal is-active">
    <div class="modal-background" (click)="onCloseModal()"></div>
    <div class="modal-content">
        <div class="box">
            @if(isReactivation) {
                <h1 class="title">Reactivar cliente</h1>
            } @else {
                <h1 class="title">Dar de baja cliente</h1>
            }
            <div class="select-container">
                <div class="column is-12">
                    @if(isReactivation) {
                        <span>
                            ¿Está seguro/a que desea reactivar este cliente?
                        </span>
                    } @else {
                        <span style="display: block; margin-bottom: 20px;">
                            Seleccione la fecha de finalización para dar de baja al cliente:
                        </span>
                        <div class="field">
                            <label class="label">Fecha de finalización</label>
                            <p-calendar 
                                [iconDisplay]="'input'" 
                                dateFormat="dd/mm/yy" 
                                dataType="date" 
                                [showIcon]="true" 
                                inputId="endDate" 
                                [(ngModel)]="endDate"
                                [minDate]="minDate"
                            />
                        </div>
                    }
                </div>
            </div>
            @if (errorMessage) {
                <p class="help is-danger" style="margin-bottom: 12px;">{{ errorMessage }}</p>
            }
            <div class="buttons-container">
                <button class="button is-outlined cancel-button" (click)="onCloseModal()" [disabled]="isSaving">Cancelar</button>
                <button 
                    class="comment-button button" 
                    (click)="onConfirm()"
                    [disabled]="isSaving || (!isReactivation && !endDate)"
                >
                    Aceptar
                </button>      
            </div>             
        </div>
    </div>
</div>

